import { Component, OnInit, Input } from '@angular/core';
import { SampleService } from '../../../core/http/sample.service';
import { SettingsService } from '../../../core/http/settings.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';

@Component({
  selector: 'app-sample-collect-modal',
  templateUrl: './sample-collect-modal.component.html',
  styleUrls: ['./sample-collect-modal.component.scss'],
})
export class SampleCollectModalComponent implements OnInit {
  @Input() data;
  samples: any = [];
  isLoading = true;
  Errors = null;
  encounters: any = [];
  Success;
  billId;
  message;
  count: number = 0;
  startdate = '';
  enddate = '';
  edit: any = [];
  bulk: any = [];
  disable: boolean = true;
  buildLoad: boolean = false;
  color = 'white';
  subDepts: any = [];
  depts: any = [];
  sub_dept_code;
  dept_code;
  barMessage;
  barVisile: boolean = false;
  date: string;

  stateForm = new FormGroup({
    id: new FormControl('', Validators.required),
    bill_id: new FormControl('', Validators.required),
    is_collect_action: new FormControl('', Validators.required),
    is_acknowledge_action: new FormControl('', Validators.required),
  });

  constructor(
    private sample: SampleService,
    private _snackBar: MatSnackBar,
    private setting: SettingsService,
    private location: Location
  ) {
    this.date = new Date().toLocaleDateString();
  }

  ngOnInit(): void {
    // console.log(this.data)
    this.isLoading = true;
    this.setting.getDept().subscribe(
      (resSuccess) => {
        this.depts = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
      }
    );
    this.setting.getSubDept().subscribe(
      (resSuccess) => {
        this.subDepts = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
      }
    );
    this.sample.getSamples(this.data.bill_id).subscribe(
      (resSuccess: any) => {
        // this.samples = [];
        this.isLoading = false;
        this.samples = resSuccess.filter(
          (t) => t.department_name == 'LABORATORY'
        );
        // console.log(this.samples)

        this.edit = this.samples.map((item) => ({
          selected: false,
          id: item.id,
          bill_id: item.bill_id,
          Sex: item.Sex,
          ack_by: item.ack_by,
          ack_out_date: item.ack_out_date,
          ack_out_time: item.ack_out_time,
          age: item.age,
          bill_date: item.bill_date,
          bill_no: item.bill_no,
          bill_time: item.bill_time,
          color: item.color,
          courier_id: item.courier_id,
          department_code: item.department_code,
          department_name: item.department_name,
          lab_regno: item.lab_regno,
          opd_ipd: item.opd_ipd,
          pat_title_id: item.pat_title_id,
          patient_name: item.patient_name,
          patient_type: item.patient_type,
          recd_unit: item.recd_unit,
          receipt_no: item.receipt_no,
          referred_doctor: item.referred_doctor,
          reg_no: item.reg_no,
          report_dispatch_mode: item.report_dispatch_mode,
          sample_acknowledged: item.sample_acknowledged,
          sample_by: item.sample_by,
          sample_collect_date: item.sample_collect_date,
          sample_collect_time: item.sample_collect_time,
          sample_collected: item.sample_collected,
          service_code: item.service_code,
          service_name: item.service_name,
          sub_code: item.sub_code,
          sub_department_name: item.sub_department_name,
        }));
        console.log(this.edit);
      },
      (resErr) => {
        this.isLoading = false;
        // this.Errors = resErr;
      }
    );
  }
  getSamples(billId) {
    this.sample.getSamples(this.data.bill_id).subscribe(
      (resSuccess: any) => {
        this.samples = [];
        this.samples = resSuccess.filter(
          (t) => t.department_name == 'LABORATORY'
        );
        this.edit = this.samples.map((item) => ({
          selected: false,
          id: item.id,
          bill_id: item.bill_id,
          Sex: item.Sex,
          ack_by: item.ack_by,
          ack_out_date: item.ack_out_date,
          ack_out_time: item.ack_out_time,
          age: item.age,
          bill_date: item.bill_date,
          bill_no: item.bill_no,
          bill_time: item.bill_time,
          color: item.color,
          courier_id: item.courier_id,
          department_code: item.department_code,
          department_name: item.department_name,
          lab_regno: item.lab_regno,
          opd_ipd: item.opd_ipd,
          pat_title_id: item.pat_title_id,
          patient_name: item.patient_name,
          patient_type: item.patient_type,
          recd_unit: item.recd_unit,
          receipt_no: item.receipt_no,
          referred_doctor: item.referred_doctor,
          reg_no: item.reg_no,
          report_dispatch_mode: item.report_dispatch_mode,
          sample_acknowledged: item.sample_acknowledged,
          sample_by: item.sample_by,
          sample_collect_date: item.sample_collect_date,
          sample_collect_time: item.sample_collect_time,
          sample_collected: item.sample_collected,
          service_code: item.service_code,
          service_name: item.service_name,
          sub_code: item.sub_code,
          sub_department_name: item.sub_department_name,
        }));
        console.log(this.edit);
      },
      (resErr) => {
        // this.Errors = resErr;
      }
    );
  }
  finish() {
    setTimeout(function () {
      this._snackBar.open('Sample collection completed', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
    }, 10000);
  }

  collectAll() {
    this.count = 0;
    this._snackBar.open('Wait while samples are collected', '', {
      duration: 2000,
      verticalPosition: 'top',
    });

    let count = 0;
    // console.log(this.bulk);
    let i;
    for (i = 0; i < this.bulk.length; i++) {
      this.onSubmitAll(this.bulk[i].id, this.bulk[i].bill_id);
      // console.log(i);
    }

    // switch(count) {
    //   case this.bulk.lenght:
    //     console.log("woked");

    //     this._snackBar.open('Sample Collection Completed', '', {
    //           duration: 2000,
    //           verticalPosition: 'top',
    //         });
    //     break;
    //   case 1000:
    //     // code block
    //     break;
    //   default:
    //     // code block
    // }

    // console.log(i)
  }

  sub(event) {
    console.log(this.sub_dept_code);
    this.barVisile = false;
    this.sample.getBarcode(this.data.bill_id, event.value).subscribe(
      (resSuccess) => {
        this.barMessage = resSuccess;
        console.log(resSuccess);
        if (this.barMessage.success) {
          if (this.barMessage.data.length == 0) {
            this._snackBar.open('No sample for this sub department', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          } else {
            this.barVisile = true;
            this._snackBar.open('Barcode loaded successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        } else {
          console.log('error');
          this._snackBar.open(this.barMessage.message, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  barcode() {}

  collectSelected() {
    this.count = 0;
    this._snackBar.open('Wait while samples are collected', '', {
      duration: 2000,
      verticalPosition: 'top',
    });

    let count = 0;
    // console.log(this.bulk);
    let i;
    for (i = 0; i < this.bulk.length; i++) {
      this.onSubmitAll(this.bulk[i].id, this.bulk[i].bill_id);
      // console.log(i);
    }

    this.bulk = [];
  }

  markAll() {
    this.bulk = this.edit;
    this.collectSelected();
  }

  check(values: any, isCkecked: any) {
    console.log(values, isCkecked.currentTarget.checked);
    if (isCkecked.currentTarget.checked) {
      this.bulk = this.bulk.filter((t) => t.id !== values.id);
      this.bulk.push(values);
      if (this.bulk.lenght < 1) {
        this.disable = true;
      } else {
        this.disable = false;
      }
    } else {
      this.bulk = this.bulk.filter((t) => t.id !== values.id);
      if (this.bulk.lenght < 1) {
        this.disable = true;
      } else {
        this.disable = false;
      }
    }
    console.log(this.bulk);
  }

  onSubmit(e) {
    // e.preventDefault();
    this.buildLoad = true;
    this.stateForm.patchValue({
      id: e.id,
      bill_id: e.bill_id,
      is_collect_action: true,
    });
    console.log(this.stateForm.value);
    this.Errors = null;
    this.Success = null;
    const { id, bill_id, is_collect_action, is_acknowledge_action } =
      this.stateForm.value;
    this.sample
      .updateRecord(id, bill_id, is_collect_action, is_acknowledge_action)
      .subscribe(
        (resSuccess) => {
          this.message = resSuccess;
          this.buildLoad = false;
          console.log(resSuccess);

          if (this.message.success) {
            this.getSamples(this.billId);
            this._snackBar.open('Sample Collected Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            // window.location.reload();
          } else {
            this.Errors = 'Not successful, please try again';
            console.log('error');
            this._snackBar.open('Sample Already Colected', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
          }
        },
        (resErr) => {
          this.buildLoad = false;
          this.Errors = resErr;
          this._snackBar.open('Error Please Try Agian', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resErr);
        }
      );
  }

  onSubmitAll(Id, billId) {
    // e.preventDefault();
    let count = 0;
    this.stateForm.patchValue({
      id: Id,
      bill_id: billId,
      is_collect_action: true,
    });
    console.log(this.stateForm.value);
    this.Errors = null;
    this.Success = null;
    const { id, bill_id, is_collect_action, is_acknowledge_action } =
      this.stateForm.value;
    this.sample
      .updateRecord(id, bill_id, is_collect_action, is_acknowledge_action)
      .subscribe(
        (resSuccess) => {
          count++;

          this.message = resSuccess;
          this.isLoading = false;
          console.log(resSuccess);
          // if ( this.bulk.lenght != count){
          //   this._snackBar.open('Sample Collection Completed', '', {
          //     duration: 2000,
          //     verticalPosition: 'top',
          //   });
          // }

          if (this.message.success) {
            this.getSamples(this.billId);
            // this._snackBar.open('Sample Collected Successfully', '', {
            //   duration: 2000,
            //   verticalPosition: 'top',
            // });
            // window.location.reload();
          } else {
            this.Errors = 'Sample Already Collected';
            console.log('error');
            // this._snackBar.open('Sample Already Collected', '', {
            //   duration: 2000,
            //   verticalPosition: 'top',
            // });
          }
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          // this._snackBar.open('Error please try again', '', {
          //   duration: 2000,
          //   verticalPosition: 'top',
          // });
          console.log(resErr);
        }
      );
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #print-section {
            width: 500px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }
}
